import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    const pixelId = '2782582688765590';
    // Prevent double-init (e.g. React StrictMode dev double-invoke)
    // @ts-ignore
    if (window.fbq) {
      try {
        // @ts-ignore
        window.fbq('track', 'PageView');
      } catch (e) {
        // no-op
      }
      return;
    }
    // Initialize fbq stub
    // @ts-ignore
    const n: any = function (...args: any[]) {
      // @ts-ignore
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    // @ts-ignore
    window.fbq = n;
    // @ts-ignore
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    // Inject the Facebook events script safely into <head>
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // @ts-ignore
    window.fbq('init', pixelId);
    // @ts-ignore
    window.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-123">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=2782582688765590&ev=PageView&noscript=1" alt="" data-id="element-124" />
    </noscript>;
}